(function ($) {

    // function updateMaxHeight() {
    //     var maxHeight = 0;
    //     $('.about-rated-by .items .item').each(function (index, el) {
    //         $(el).height();
    //         if (maxHeight < $(el).height()) maxHeight = $(el).height();
    //     });
    //
    //     $('.about-rated-by .items .item').each(function (index, el) {
    //         $(el).height(maxHeight);
    //     });
    // }
    // var imgs = $('.about-rated-by .items img'),
    //     len = $('.about-rated-by .items img').length,
    //     counter = 0;
    //
    // imgs.each(function(index, el) {
    //     $(el).load(function() {
    //         incrementCounter();
    //     });
    // });
    //
    // function incrementCounter() {
    //     counter++;
    //     if ( counter >= len ) {
    //         $('.about-rated-by .items .item').css('height','auto');
    //         // updateMaxHeight();
    //     }
    // }

    function esrbUpdatePushers() {
        $('.about-rated-by .items .excerpt').each(function(index, el) {
            var height = $(el).height();
            var pusher = $(el).find('.pusher');
            pusher.height(height - 75);
        });
    }

    // add SquarePusher to items
    esrbUpdatePushers();
    $(window).on('resize', function(){
        esrbUpdatePushers();
        // $('.about-rated-by .items .item').css('height','auto');
        // updateMaxHeight();
    });

    $('.about-rated-by .items').on('init breakpoint', function(event, slick, currentSlide, nextSlide) {
        esrbUpdatePushers();
        // $('.about-rated-by .items .item').css('height','auto');
        // updateMaxHeight();
    });

    $('.about-rated-by .items').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: $('.about-rated-by .nav .prev'),
        nextArrow: $('.about-rated-by .nav .next'),
        responsive: [
            { breakpoint: 2500 },
            { breakpoint: 2160 },
            { breakpoint: 1860 },
            { breakpoint: 1400 },
            { breakpoint: 1200 },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
})(jQuery);